
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiLguYPguJnguYLguIbguKnguJPguLLguYPguKvguYnguIvguYjguK3guJnguYTguKfguYkifQ==!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiLguYPguJnguYLguIbguKnguJPguLLguYPguKvguYnguIvguYjguK3guJnguYTguKfguYkifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJ0ZXJzZW1idW55aSBkaSBpa2xhbiJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJ0ZXJzZW1idW55aSBkaSBpa2xhbiJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiLguYPguJnguYLguIbguKnguJPguLLguYPguKvguYnguIvguYjguK3guJnguYTguKfguYkifQ==!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiLguYPguJnguYLguIbguKnguJPguLLguYPguKvguYnguIvguYjguK3guJnguYTguKfguYkifQ==!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJ0ZXJzZW1idW55aSBkaSBpa2xhbiJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJ0ZXJzZW1idW55aSBkaSBpa2xhbiJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJoaWRkZW4gb24gYWQifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJb4bipw6zDrMOsxozGjOG6veG6veG6veC4geC4teC5iSDDtsO2w7bguIHguLXguYkgxIPEg8SDxoxdIn0=!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJoaWRkZW4gb24gYWQiOiJb4bipw6zDrMOsxozGjOG6veG6veG6veC4geC4teC5iSDDtsO2w7bguIHguLXguYkgxIPEg8SDxoxdIn0=!"
        )
      )
      });
  
      export { translations as translations };
    